<template>
  <div class="main scroll" ref="scroll">
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            班级相册
          </div>
           <a-button style="margin-left:10px;font-size:12px" type="default" size="small" @click="downloadImgs">下载照片</a-button>
        </div>
        <!-- <div class="right">
          <div class="num">
            已建立本班相册<span class="blue">{{ albumList.length }}</span>
          </div>
          <div class="msg">
            <div class="txt blue">相册信息</div>
            <a-icon style="{color:#898989}" type="caret-down" />
          </div>
        </div> -->
      </div>
      <div class="content">
        <div class="frame-list">
          <div
            @click="toclassalbum(index)"
            v-for="(item, index) in albumList"
            :key="index"
            class="cell"
            :style="{
              backgroundImage: item.select
                ? 'url(' + backimg2 + ')'
                : 'url(' + backimg1 + ')',
            }"
          >
            <div class="msg">
              <div class="top">
                <div class="name">{{ item.name }}</div>
              </div>
              <div class="foot">
                <div class="order"></div>
                <div class="num">照片数量：{{ item.count }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            学生相册
          </div>
        </div>
      </div>
      <div class="content">
        <div class="student-list">
          <div
            @click="toStundentAlbum(index)"
            v-for="(item, index) in studentList"
            :key="index"
            class="cell"
          >
            <img
              class="tx"
              :src="
                item.head_img ? item.head_img : require('../assets/user.png')
              "
              alt=""
            />
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            成长册
          </div>
        </div>
      </div>
      <div class="content">
        <div class="plate-list">
          <div
            @click="tapPlate(item)"
            v-for="(item, index) in plateList"
            :key="index"
            class="cell"
          >
            <div
              class="cover"
              :style="{ backgroundImage: 'url(' + item.guc_thumb + ')' }"
            ></div>
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      albumList: [],
      currentAlbum: null,
      currentIndex: -1,
      rightContentLeft: 0,
      rightContentTop: 0,
      showRight: false,
      albumName: "",
      createModal: false,
      editModal: false,
      delModal: false,
      backimg1: require("../assets/doc-02.png"),
      backimg2: require("../assets/doc-01.png"),
      studentList: [],
      rightStyle: {
        left: 0,
        top: 0,
      },
      plateList: [],
    };
  },
  mounted() {},
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    if (this.userInfo) {
      this.getClassRecord();
    }
  },
  filters: {
    filterIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getClassRecord();
      }
    },
  },
  methods: {
    tapPlate(plate) {
      // this.studentList.forEach((arr)=>{
      //   if (arr.name == plate.name) {
      //     this.$router.push({
      //       path: "/mobileGrowupBook/" + arr.id + "/" + plate.guc_id,
      //       query: { name: plate.name },
      //     });
      //   }
      // })
      
      // return
      localStorage.setItem('canEdit', plate.force_edit ? true : false);
      this.$router.push({
        path: "/growupRecord/" + plate.id + "/" + plate.guc_id,
        query: { name: plate.name, complete_id: this.record.c_id },
      });
    },
    downloadImgs() {
      if (this.albumList.length == 0) {
        this.$message.error('此归档暂无相册');
        return
      }
      this.$confirm({
        title: '提示',
        content: '您可以根据图片地址使用迅雷批量下载',
        confirmButtonText: '我知道了',
        cancelButtonText: '取消',
        type: 'info',
        centered: true,
        onOk: () => {
          this.$message.loading({
        key: 'download',
        content: '正在获取照片地址...'
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.downloadImgs,
        headers: { Authorization: this.headers },
        data: {
          album_id: this.albumList.map(item => item.id).join(','),
        }
      })
        .then((res) => {
          console.log(res);
          this.$message.destroy('download');
          if (res.data) {
            const urls = res.data;
            if (urls.length > 0) {
              // 创建txt文件内容
              const content = res.data
              // 创建Blob对象
              const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
              // 创建下载链接
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = `${this.albumName}_photos.txt`;
              // 触发下载
              document.body.appendChild(link);
              link.click();
              // 清理
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              this.$message.success('照片地址下载成功');
            } else {
              this.$message.info(res.msg);
            }
          } else {
            this.$message.error(res.data.msg || '获取照片地址失败');
          }
        })
        .catch((error) => {
          this.$message.destroy('download');
          console.error('下载照片地址失败:', error);
          this.$message.error('网络或服务器错误');
        });
        },
      })
      
    },
    getClassRecord() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.classRecord,
        headers: { Authorization: this.headers },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.record = res.data.data[this.$route.params.index];
            console.log(this.record);
            this.getAlbum();
            this.getStudent();
            this.getPlate();
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    toclassalbum(index) {
      this.$router.push({
        path: `/classAlbumRecord/${this.albumList[index].id}`,
        query: { name: this.albumList[index].name },
      });
    },
    toStundentAlbum(index) {
      this.$router.push({
        path: `/studentAlbumRecord/${this.studentList[index].id}/${this.record.c_id}`,
        query: { name: this.studentList[index].name },
      });
    },
    getPlate() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.growPlateList,
        headers: { Authorization: this.headers },
        data: {
          complete_id: this.record.c_id,
          limit: 100,
          page: 1,
        }
        }).then((res) => {
          if (res.data.status == 200) {
            this.plateList = res.data.data.list;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
        data: {
          complete_id: this.record.c_id,
          limit: 100,
          page: 1,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.studentList = res.data.data.rows;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getAlbum() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumList,
        headers: { Authorization: this.$store.state.headers },
        data: {
          complete_id: this.record.c_id,
          class_id: this.userInfo.class_id,
          limit: 200,
          page: 1,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.albumList = res.data.data.data.map((arr) => {
              arr.select = false;
              return arr;
            });
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.student-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  .cell {
    cursor: pointer;
    margin-bottom: 30px;
  }
  .tx {
    width: 60px;
    height: 60px;
    border-radius: 60px;
    margin-right: 30px;
  }
  .name {
    width: 60px;
    text-align: center;
    color: #888;
    margin-top: 10px;
    font-size: 14px;
  }
}
.scroll {
  position: absolute;
  left: -20px;
  right: -20px;
  padding-left: 20px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  box-sizing: border-box;
  .scroll-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addframe {
    width: 175px;
    margin-bottom: 30px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }
  .cell {
    width: 175px;
    height: 120px;
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    padding: 25px 15px 15px 15px;
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-right: 30px;
    .tx {
      width: 92px;
      height: 92px;
      margin-right: 20px;
    }
    &.select {
      border: 3px solid #67b0dc;
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        .name {
          word-break: break-all;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          line-height: 1.3;
          -webkit-line-clamp: 2;
        }
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        margin-bottom: 10px;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
          color: #fff;
        }
      }
    }
  }
}
.frame-list div,
.frame-list span {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -ms-user-select: none;
}
::-webkit-scrollbar-track-piece {
  background-color: #f1f1f1;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #a8b3bb;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
.plate-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  flex-wrap: wrap;
  .cell {
    width: 130px;
    margin-right: 30px;
    margin-bottom: 30px;
    .cover {
      width: 100%;
      height: 168px;
      background-size: contain;
    }
    .name {
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-top: 15px;
    }
  }
}
</style>
